import React from 'react';

interface ComponentProps {
  count: number | React.ReactNode;
  countLabel?: string;
  countClassName?: string;
  title?: string;
  icon?: React.ReactNode;
  criteria?: string[];
}

const SummaryStatCard: React.FC<ComponentProps> = ({ count, countLabel, countClassName, title, icon, criteria }) => (
  <div className="summary-card h-100 d-flex flex-column p-3 border rounded bg-white shadow-sm">
    <div>
      {/* Title block (optional) */}
      {title && (
        <div className="d-flex align-items-center mb-3">
          {icon && <div className="me-2 text-secondary">{icon}</div>}
          <div className="mb-0 fw-semibold text-muted">{title}</div>
        </div>
      )}

      {/* Count block (always shown) */}
      <div className="text-center my-3">
        <div className={`fs-1 fw-bold ${countClassName || ''}`}>{count}</div>
        {countLabel && <div className="text-muted">{countLabel}</div>}
      </div>
    </div>

    {/* Criteria (optional) */}
    {Array.isArray(criteria) && criteria.length > 0 && (
      <div className="criteria-box bg-light p-3 rounded small mt-2">
        <div className="fw-semibold text-muted mb-2">Criteria:</div>
        <ul className="mb-0 ps-3 text-muted">
          {criteria.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </div>
    )}
  </div>
);

export default SummaryStatCard;
